import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatLocaleNumber',
    standalone: false,
    pure: true
})
export class FormatLocaleNumberPipe implements PipeTransform {
  transform(value: number | undefined): string {
    if (value === undefined || value === null) {return '';}
    return value.toLocaleString();
  }
}
